<template>
    <div class="container-fluid">
        <admin-header :name="$t('Dashboard')" @create="gridView" :title="title" add-new />
        <app-card>
            <router-view name="dashboard"/>
        </app-card>
    </div>
</template>

<script>
export default {
    computed: {
        title() {
            if (this.$route.fullPath === '/auth/dashboard' || this.$route.fullPath === '/auth/dashboard/') {
                return 'Booking table';
            } else {
                return 'Dashboard';
            }
        }
    },
    methods: {
        gridView() {
            if (this.$route.fullPath === '/auth/dashboard' || this.$route.fullPath === '/auth/dashboard/') {
                this.$router.push({name:'grid.view'});
            } else {
                this.$router.push({name:'dashboard'});
            }
        }
    },
    metaInfo() {
        return {
            title: this.$t('Dashboard')
        };
    }
};
</script>
